import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { SendResetPasswordEmail } from "../../api";
import KurvFooter from "./KurvFooter";
import "./KurvForgotPassword.scss";

const KurvForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setMessage("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            return;
        }

        setIsSubmitting(true);
        
        try {
            await SendResetPasswordEmail({ email });
            setMessage("If you are a registered user, you will get your reset link in the email.");
            setIsSubmitted(true);
        } catch (error) {
            setMessage("If you are a registered user, you will get your reset link in the email.");
            setIsSubmitted(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="kurv-forgot-password-page">
            <div className="hero-image-background" />
            <div className="kurv-forgot-password-container">
                <div className="kurv-logo">
                    <img 
                        src="/images/kurv-agent/kurv-logo.svg" 
                        alt="Kurv Agent" 
                        className="logo-image"
                    />
                </div>

                <div className="kurv-forgot-card">
                    <div className="kurv-forgot-top">
                        <Link to="/" className="kurv-back-button">
                            <FontAwesomeIcon icon={faArrowLeft} className="back-icon" />
                            <span>Back</span>
                        </Link>
                        
                        <div className="kurv-forgot-title">
                            <h2 className="title-text">Reset password</h2>
                            <p className="subtitle-text">
                                Enter your email address below to reset your password.
                            </p>
                        </div>
                    </div>

                    <Form onSubmit={handleSubmit} className="kurv-forgot-form">
                        <div className="kurv-forgot-form-group">
                            <label className="kurv-forgot-label">Email</label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={handleEmailChange}
                                className="kurv-forgot-input"
                                placeholder="Email"
                                required
                            />
                        </div>

                        {message && (
                            <div className="kurv-forgot-message">
                                {message}
                            </div>
                        )}

                        <Button
                            type="submit"
                            className="kurv-forgot-submit-button"
                            disabled={!email}
                        >
                            Send Instructions
                        </Button>
                    </Form>
                </div>

                <a
                    href="https://myportfolio.emscorporate.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="kurv-stratus-logo"
                >
                    <img
                        src="/images/kurv-agent/myportfolio-logo.png"
                        alt="My Portfolio"
                    />
                </a>
            </div>

            <KurvFooter />
        </div>
    );
};

export default KurvForgotPassword;

